import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import ChevronRightIcon from '@ps-design-system/icons/ChevronRight/ChevronRight24';

import { RadioSelector } from './components/radio-selector';
import { ButtonSelector } from './components/button-selector';
import { useFlagMessageContext } from './utils/utils';

export const FlagCategoryFlow = () => {
  const {
    setSelectedCategory,
    selectedReason,
    selectedCategory,
    flagMessage,
    setCurrentStep,
    currentStep
  } = useFlagMessageContext();

  const goToDetails = useCallback(() => {
    setCurrentStep('details');
  }, [currentStep]);

  if (isEmpty(selectedReason.categories)) {
    return null;
  }

  return <div className="flag-message-modal-body">
    <p className="flag-message-modal-text with-back-button">
      <FormattedMessage
        id="stream.flag_message.select_reason"
        defaultMessage="Please select the issue you are having. This will only be shared with Peerspace."
      />
    </p>
    <hr className="no-margin" />
    <div className="flag-message-modal-radio-group flex middle space-between column">
      {map(selectedReason.categories, (category => {
        const onChane = () => {
          setSelectedCategory(category);
        };

        return <>
          <RadioSelector
            value={category.value}
            id={category.value}
            name={category.value}
            onChange={onChane}
            checked={selectedCategory?.value === category.value}
            label={category.title}
          />
          <hr className="no-margin full-width" />
        </>;
      }))}
    </div>
    <ButtonSelector onClick={goToDetails}>
      <div className="button-body flex space-between middle full-width">
        <FormattedMessage id="stream.reasons.something_else" defaultMessage="Something else" />
        <ChevronRightIcon />
      </div>
    </ButtonSelector>
    <hr className="no-margin" />
    <div className="flag-message-modal-footer flex end">
      <button
        className="btn btn-secondary"
        type="button"
        onClick={flagMessage}
        disabled={!selectedCategory}
      >
        <FormattedMessage id="stream.flag_message.submit" defaultMessage="Submit" />
      </button>
    </div>
  </div>;
};
